export default {
	theme: { disable: true },
	icons: {
		iconfont: 'icomoon',
		values: {
			expand: 'icon-chevron-down',
			dropdown: 'icon-chevron-down',
			clear: 'icon-close'
		}
	},
}
